// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_Frn","cls2":"Comments-cls2_Ji2 Comments-cls1_Frn"};